import { useEffect, useRef } from 'react'
import { getLocaleParam } from '~/utils'

export function useInitialLocale(locationSearch) {
  const localeRef = useRef('')

  useEffect(() => {
    const localeFromParam = getLocaleParam(locationSearch)?.locale
    const localeFromStorage = sessionStorage.getItem('gfnd.session.query')

    if (localeFromStorage) {
      try {
        const parsed = JSON.parse(localeFromStorage)
        localeRef.current = parsed?.locale || ''
      } catch (e) {
        console.warn('Falha ao realizar parse do sessionStorage:', e)
      }
    } else if (localeFromParam) {
      localeRef.current = localeFromParam
    }
  }, [])

  return localeRef
}
